import React from "react"
import SbEditable from "storyblok-react"
import { blokType, sbAssetType } from "../../types"

import MediaCmp, { MediaProps } from "./Media"

export interface MediaWrapperBlokProps {
  blok: MediaProps & blokType
  media: sbAssetType
  video_url: string;
  aspect_ratio: string
  video_controls: boolean
  video_loop: boolean
  video_autoplay: boolean
  video_muted: boolean
  button_label: string
  external_video: string
  video_url: string;
  youvisit_url: string
  mobile_image: sbAssetType
  mobile_aspect_ratio: string
  play_at_current_size: boolean
}

const S23CMedia: React.FC<MediaWrapperBlokProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <MediaCmp
      media={blok.media}
      video_url={blok.video_url}
      aspect_ratio={blok.aspect_ratio}
      video_controls={blok.video_controls}
      video_loop={blok.video_loop}
      video_autoplay={blok.video_autoplay}
      video_muted={blok.video_muted}
      button_label={blok.button_label}
      external_video={blok.external_video}
      video_url={blok.video_url}
      youvisit_url={blok.youvisit_url}
      mobile_image={blok.mobile_image}
      mobile_aspect_ratio={blok.mobile_aspect_ratio}
      play_at_current_size={blok.play_at_current_size}

    />
  </SbEditable>
)

export default S23CMedia 
